import styled from "styled-components";

interface ConfirmModalProps {
  visible: boolean;
  title: string;
  subtitle?: string;
  onConfirm: () => void;
  /** 있으면 취소/확인 2버튼(여부 확인용), 없으면 확인 1버튼(완료 안내용). */
  onCancel?: () => void;
  confirmText?: string;
}

/**
 * 여부 확인(취소/확인 2버튼)과 완료 안내(확인 1버튼) 공통으로 쓰는 범용 모달.
 * 목업: biz-ttori projects/close/Docs/디자인/{주문취소 여부/완료, 환불처리 여부/완료, 환불 리스트 삭제 여부/완료}.png
 */
const ConfirmModal = ({
  visible,
  title,
  subtitle,
  onConfirm,
  onCancel,
  confirmText = "확인",
}: ConfirmModalProps) => {
  if (!visible) return null;

  return (
    <Container>
      <ModalBox role="dialog" aria-modal="true" aria-label={title}>
        <Title>{title}</Title>
        {subtitle && <SubTitle>{subtitle}</SubTitle>}
        <BtnRow>
          {onCancel && <CancelBtn type="button" onClick={onCancel}>취소</CancelBtn>}
          <ConfirmBtn type="button" onClick={onConfirm}>{confirmText}</ConfirmBtn>
        </BtnRow>
      </ModalBox>
    </Container>
  );
};

export default ConfirmModal;

const Container = styled.div`
  z-index: 200;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: calc(100% - 24px);
  max-width: 340px;
  background-color: var(--admin-theme-surface, var(--user-surface));
  border-radius: 8px;
  padding: 44px 30px;
  text-align: center;
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
`;

const Title = styled.div`
  font-size: 17px;
  font-family: var(--font-Pretendard-SemiBold);
  color: var(--admin-theme-text, var(--user-text));
`;

const SubTitle = styled.div`
  margin-top: 20px;
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  color: var(--admin-theme-link, var(--user-accent));
`;

const BtnRow = styled.div`
  margin-top: 36px;
  display: flex;
  gap: 8px;
`;

const CancelBtn = styled.button`
  border: 0;
  min-height: 44px;
  &:focus-visible { outline: 2px solid var(--admin-theme-focus, var(--user-accent)); outline-offset: 2px; }
  flex: 1;
  padding: 14px;
  border-radius: 8px;
  background-color: var(--admin-theme-raised, var(--user-surface-raised));
  color: var(--admin-theme-muted, var(--user-text-muted));
  font-size: 15px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const ConfirmBtn = styled.button`
  border: 0;
  min-height: 44px;
  &:focus-visible { outline: 2px solid var(--admin-theme-focus, var(--user-accent)); outline-offset: 2px; }
  flex: 1;
  padding: 14px;
  border-radius: 8px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
  font-size: 15px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;
